import { Clipboard } from '@angular/cdk/clipboard';
import { inject, Injectable } from '@angular/core';
import { filter, Observable, of, tap } from 'rxjs';
import { ResolverApiService } from './resolver-api.service';
import { ResolverCopyDialogService } from './resolver-copy-dialog';

@Injectable({
  providedIn: 'root'
})
export class ResolverService {
  private api = inject(ResolverApiService);
  private resolverCopyDialogService = inject(ResolverCopyDialogService);
  private clipboard = inject(Clipboard);

  copyUrl(url: string): Observable<string> {
    if (!this.api.baseApiUrl) {
      this.clipboard.copy(url);
      return of(url);
    }

    // Resolve URL via Resolver API in dialog for Safari
    return this.resolverCopyDialogService
      .open$({
        url
      })
      .pipe(
        // @ts-expect-error foo
        filter((prettyUrl) => !!prettyUrl),
        tap((prettyUrl) => {
          this.clipboard.copy(prettyUrl);
        })
      );
  }
}
